export default __webpack_public_path__ + "static/media/outreachBanner.d8e14136.jpg";